import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface ToggleViewLabelProps {
  children: React.ReactNode;
}

const LabelComponent: React.FC<ToggleViewLabelProps> = ({ children }) => {
  return <span className="peptalk-toggle-label">{children}</span>;
};

export const Label: React.FC<ToggleViewLabelProps> = (
  props: ToggleViewLabelProps
) => {
  const Component = useCustomComponent({
    componentName: 'ToggleViewLabel',
    Component: LabelComponent,
  });

  return <Component {...props} />;
};
